// extracted by mini-css-extract-plugin
export default {"messageListBox":"components-user-CreateUserDialog-__messageListBox"};